export default __webpack_public_path__ + "static/media/checkbox-blue-active.57628d55.svg";